import { HttpClient } from '@remodeling/base';
import {
  GetConsultInfoRequest,
  GetQuickConsultBasicInfoResponse,
  GetQuickConsultDetailRequest,
  GetQuickConsultDetailResponse,
  CreateQuickConsultRequest,
  CreateQuickConsultResponse,
  GetQuickConsultChannelInfoRequest,
  GetQuickConsultChannelInfoResponse,
} from '../../model';

export class GetQuickConsultChannelInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetQuickConsultChannelInfoRequest) {
    return await this.httpClient.request<GetQuickConsultChannelInfoResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/remodeling-manager-service/api/v1/consults/base/channel`,
      body: req,
    });
  }
}
export class GetQuickConsultBasicInfoGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req?: GetConsultInfoRequest) {
    return await this.httpClient.request<GetQuickConsultBasicInfoResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/remodeling-manager-service/api/v1/consults/info`,
      body: req,
    });
  }
}

export class CreateQuickConsultGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: CreateQuickConsultRequest) {
    return await this.httpClient.request<CreateQuickConsultResponse>({
      method: 'POST',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/remodeling-manager-service/api/v1/consults/base`,
      body: req,
    });
  }
}

export class GetQuickConsultDetailGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetQuickConsultDetailRequest) {
    return await this.httpClient.request<GetQuickConsultDetailResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/remodeling-manager-service/api/v1/consults/${req.id}/base`,
    });
  }
}
